import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { authApi, getDisplayMessage } from '@/api/apiClient';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

export default function RedefinirSenhaPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [novaSenha, setNovaSenha] = useState('');
  const [confirmaSenha, setConfirmaSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (novaSenha.length < 6) {
      setError('A senha deve ter no mínimo 6 caracteres');
      return;
    }
    if (novaSenha !== confirmaSenha) {
      setError('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      await authApi.redefinirSenha(token, novaSenha, confirmaSenha);
      setSuccess(true);
      setTimeout(() => navigate('/Login'), 2000);
    } catch (err) {
      setError(getDisplayMessage(err, 'Erro ao redefinir senha. Tente novamente.'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 p-4">
        <Card className="w-full max-w-md shadow-xl border-none">
          <CardHeader className="text-center pb-4">
            <div className="flex justify-center mb-4">
              <img
                src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/68e50deef22388676f24e5ca/058df03c3_LogoAuction.png"
                alt="Auction Logo"
                className="h-16 w-auto object-contain"
              />
            </div>
            <CardTitle className="text-2xl font-bold text-slate-900">Link inválido ou expirado</CardTitle>
            <CardDescription className="mt-2">
              O link de redefinição não foi encontrado ou já expirou. Solicite uma nova redefinição de senha.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/EsqueciSenha">
              <Button variant="outline" className="w-full">
                Solicitar novo link
              </Button>
            </Link>
            <p className="mt-4 text-center text-sm text-slate-600">
              <Link to="/Login" className="text-blue-600 hover:underline">
                Voltar para login
              </Link>
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 p-4">
        <Card className="w-full max-w-md shadow-xl border-none">
          <CardHeader className="text-center pb-4">
            <CardTitle className="text-2xl font-bold text-slate-900">Senha redefinida!</CardTitle>
            <CardDescription className="mt-2">
              Sua senha foi alterada com sucesso. Redirecionando para o login...
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 p-4">
      <Card className="w-full max-w-md shadow-xl border-none">
        <CardHeader className="text-center pb-4">
          <div className="flex justify-center mb-4">
            <img
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/68e50deef22388676f24e5ca/058df03c3_LogoAuction.png"
              alt="Auction Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
          <CardTitle className="text-2xl font-bold text-slate-900">Redefinir senha</CardTitle>
          <CardDescription className="mt-2">Informe sua nova senha</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <Alert variant="destructive">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            <div>
              <Label htmlFor="novaSenha">Nova senha</Label>
              <Input
                id="novaSenha"
                type="password"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="confirmaSenha">Confirmar senha</Label>
              <Input
                id="confirmaSenha"
                type="password"
                value={confirmaSenha}
                onChange={(e) => setConfirmaSenha(e.target.value)}
                placeholder="Repita a nova senha"
                required
                minLength={6}
                className="mt-1"
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Salvando...' : 'Redefinir senha'}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-slate-600">
            <Link to="/Login" className="text-blue-600 hover:underline">
              Voltar para login
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
